import { contextFactory } from '@frontend/design-system';

export type PlatformComponentContextValue = {
  locationId: string;
  isPublic: boolean;
  isRegularLocation: boolean;
};
export const [PlatformComponentContext, usePlatformComponentContext] = contextFactory<PlatformComponentContextValue>(
  '',
  {} as PlatformComponentContextValue
);

export type PlatformComponentProviderProps = React.PropsWithChildren<{
  locationId: string;
  isPublic: boolean;
  isRegularLocation: boolean;
}>;

export const PlatformComponentProvider = ({
  locationId,
  isPublic,
  isRegularLocation,
  children,
}: PlatformComponentProviderProps) => {
  const value = { locationId, isPublic, isRegularLocation };

  return <PlatformComponentContext.Provider value={value}>{children}</PlatformComponentContext.Provider>;
};

export const useLocationPropOrContext = (locationIdOverride?: string) => {
  const { locationId } = usePlatformComponentContext();
  return locationIdOverride || locationId;
};
